var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-title-comp"},[_c('div',{staticClass:"title-icon"},[_c('i',{staticClass:"bx-md",class:_vm.icon}),_c('div',{staticClass:"title"},[_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }